import React, {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import TrelloIntegrationCard from './components/TrelloIntegrationCard'
import JiraIntegrationCard from './components/JiraIntegrationCard'
import ClickupIntegrationCard from './components/ClickupIntegrationCard'
import SalesforceIntegrationCard from './components/SalesforceIntegrationCard'
import MondayIntegrationCard from './components/MondayIntegrationCard'
import DiscordIntegrationCard from './components/DiscordIntegrationCard'
import SlackIntegrationCard from './components/SlackIntegrationCard'
import PlannerIntegrationCard from './components/PlannerIntegrationCard'
import RdStationIntegrationCard from './components/RdStationIntegrationCard'
import {useAuth} from '../auth'

const IntegrationsPage: FC = () => {
  const {currentUser} = useAuth()

  return (
    <>
      <PageTitle breadcrumbs={[]}>Integrações</PageTitle>

      <div className='dash-section'>
        <div className='mb-6'>
          <h3 className='fw-bold fs-3 mb-1'>Integrações Externas</h3>
          <span className='text-muted fw-semibold fs-7'>
            Conecte o TaskRush com suas ferramentas favoritas
          </span>
        </div>

        <div className='row g-6'>
          {/* Trello Integration */}
          <div className='col-lg-4 col-md-6 d-flex'>
            <TrelloIntegrationCard />
          </div>

          {/* ClickUp Integration */}
          <div className='col-lg-4 col-md-6 d-flex'>
            <ClickupIntegrationCard />
          </div>

          {/* Discord Integration: só no piloto de canais (allowlist do backend) */}
          {currentUser?.channels_enabled && (
            <div className='col-lg-4 col-md-6 d-flex'>
              <DiscordIntegrationCard />
            </div>
          )}

          {/* Microsoft Planner Integration */}
          <div className='col-lg-4 col-md-6 d-flex'>
            <PlannerIntegrationCard />
          </div>

          {/* Salesforce Integration */}
          <div className='col-lg-4 col-md-6 d-flex'>
            <SalesforceIntegrationCard />
          </div>

          {/* Monday.com Integration */}
          <div className='col-lg-4 col-md-6 d-flex'>
            <MondayIntegrationCard />
          </div>

          {/* RD Station CRM (beta) */}
          <div className='col-lg-4 col-md-6 d-flex'>
            <RdStationIntegrationCard />
          </div>

          {/* Slack Integration (em breve) */}
          <div className='col-lg-4 col-md-6 d-flex'>
            <SlackIntegrationCard />
          </div>

          {/* Jira Integration (em breve) */}
          <div className='col-lg-4 col-md-6 d-flex'>
            <JiraIntegrationCard />
          </div>
        </div>

        <div className='separator my-8'></div>

        <div className='text-center'>
          <h4 className='text-muted fs-6 fw-semibold mb-3'>Mais integrações em breve!</h4>
          <p className='text-muted fs-7'>
            Estamos trabalhando para trazer mais opções de integração.
            <br />
            Tem alguma sugestão? Entre em contato conosco.
          </p>
        </div>
      </div>
    </>
  )
}

export default IntegrationsPage
